import { useQuery } from '@tanstack/react-query';
import { Navigate } from 'react-router-dom';
import { useSession } from '../context/SessionContext.jsx';
import { getNavigation } from '../api/client.js';

/**
 * Landing page. If the user's profile nominates a home report (v1's
 * `homeId`/`homeName` on the profile document) we go straight there;
 * otherwise show the customer logo, as v1 did.
 */
export default function Home() {
  const { customer, user, theme } = useSession();
  const { data: nav, isLoading } = useQuery({
    queryKey: ['navigation', 'Desktop'],
    queryFn: () => getNavigation('Desktop')
  });

  if (isLoading) {
    return <div className="embed-overlay"><div className="spinner-border text-primary" /></div>;
  }

  if (nav?.home?.reportId) {
    return <Navigate to={`/report/${nav.home.reportId}`} replace />;
  }

  const logo = (theme === 'dark' ? customer?.logos?.dark : customer?.logos?.light) ?? null;

  return (
    <div className="home-hero">
      {logo
        ? <img src={logo} alt={customer?.name ?? 'Logo'} />
        : <h1 className="display-6 mb-0">{customer?.name}</h1>}
      <p className="lead mt-4 mb-0">
        Welcome{user?.fullName ? `, ${user.fullName.split(' ')[0]}` : ''}.
      </p>
      <p className="text-secondary small mt-1 mb-0">
        Choose a report from the menu to get started.
      </p>
    </div>
  );
}
